(function($) {
  window.fnames = new Array(); window.ftypes = new Array();
  fnames[0]='EMAIL';ftypes[0]='email';
  fnames[8]='SMSPHONE';ftypes[8]='smsphone';
  fnames[1]='FNAME';ftypes[1]='text';
  fnames[2]='LNAME';ftypes[2]='text';
  fnames[3]='ADDRESS';ftypes[3]='address';
  fnames[4]='PHONE';ftypes[4]='phone';
  fnames[5]='BIRTHDAY';ftypes[5]='birthday';
  fnames[7]='TESTGROUP';ftypes[7]='number';
  fnames[6]='SIGNUPINFO';ftypes[6]='text';
}(jQuery));
var $mcj = jQuery.noConflict(true);

// SMS Phone Multi-Country Functionality
if(!window.MC) { window.MC = {}; }
window.MC.smsPhoneData = {
  defaultCountryCode: 'AU',
  programs: [{"countryCode":"AU","countryCallingCode":"+61","number":"+61485810820","imgSrc":"https://flagcdn.com/w40/au.png","requiredTemplate":"Killer Coffee Co - By providing your phone number and checking the box, you agree to receive promotional and marketing messages (e.g., abandoned carts), notifications, and customer service communications from Killer Coffee Co. Message and data rates may apply. Consent is not a condition of purchase. Message frequency varies. Text HELP for help. Text STOP to cancel. <a href=\"http://eepurl.com/joJE4w\" target=\"_blank\">See terms</a>, <a href=\"http://eepurl.com/joJE1Y\" target=\"_blank\">See Privacy Policy</a>","optionalTemplate":"Killer Coffee Co - By providing your phone number, you agree to receive promotional and marketing messages (e.g., abandoned carts), notifications, and customer service communications from Killer Coffee Co. Message and data rates may apply. Consent is not a condition of purchase. Message frequency varies. Text HELP for help. Text STOP to cancel. <a href=\"http://eepurl.com/joJE4w\" target=\"_blank\">See terms</a>, <a href=\"http://eepurl.com/joJE1Y\" target=\"_blank\">See Privacy Policy</a>","language":"en"}],
  smsProgramDataCountryNames: [{"code":"AU","name":"Australia"}]
};

function getCountryUnicodeFlag(countryCode) {
   return countryCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
};

function sanitizeHtml(str) {
  if (typeof str !== 'string') return '';
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/\//g, '&#x2F;');
}

function sanitizeUrl(url) {
  if (typeof url !== 'string') return '';
  const trimmedUrl = url.trim().toLowerCase();
  if (trimmedUrl.startsWith('javascript:') || trimmedUrl.startsWith('data:') || trimmedUrl.startsWith('vbscript:')) { return '#'; }
  return url;
}

const getBrowserLanguage = () => {
  if (!window?.navigator?.language?.split('-')[1]) { return window?.navigator?.language?.toUpperCase(); }
  return window?.navigator?.language?.split('-')[1];
};

function getDefaultCountryProgram(defaultCountryCode, smsProgramData) {
  if (!smsProgramData || smsProgramData.length === 0) { return null; }
  const browserLanguage = getBrowserLanguage();
  if (browserLanguage) {
    const foundProgram = smsProgramData.find((program) => program?.countryCode === browserLanguage);
    if (foundProgram) { return foundProgram; }
  }
  if (defaultCountryCode) {
    const foundProgram = smsProgramData.find((program) => program?.countryCode === defaultCountryCode);
    if (foundProgram) { return foundProgram; }
  }
  return smsProgramData[0];
}

function updateSmsLegalText(countryCode, fieldName) {
  if (!countryCode || !fieldName) { return; }
  const programs = window?.MC?.smsPhoneData?.programs;
  if (!programs || !Array.isArray(programs)) { return; }
  const program = programs.find(program => program?.countryCode === countryCode);
  if (!program || !program.requiredTemplate) { return; }
  var smsConsentHtmlRenderingFixEnabled = true;
  const legalTextElement = document.querySelector('#legal-text-' + fieldName);
  if (!legalTextElement) { return; }
  const blockWrapperRegex = new RegExp('</?(?:div|p)[^>]*>', 'gi');
  const template = smsConsentHtmlRenderingFixEnabled
    ? program.requiredTemplate.replace(/<\/p>\s*<p[^>]*>/gi, ' ').replace(blockWrapperRegex, '')
    : program.requiredTemplate.replace(new RegExp('</?[div][^>]*>', 'gi'), '');
  legalTextElement.textContent = '';
  const parts = template.split(/(<a href=".*?" target=".*?">.*?<\/a>)/g);
  parts.forEach(function(part) {
    if (!part) { return; }
    const anchorMatch = part.match(/<a href="(.*?)" target="(.*?)">(.*?)<\/a>/);
    if (anchorMatch) {
      const linkElement = document.createElement('a');
      linkElement.href = sanitizeUrl(anchorMatch[1]);
      linkElement.target = sanitizeHtml(anchorMatch[2]);
      linkElement.textContent = sanitizeHtml(anchorMatch[3]);
      legalTextElement.appendChild(linkElement);
    } else {
      legalTextElement.appendChild(document.createTextNode(part));
    }
  });
}

function generateDropdownOptions(smsProgramData) {
  if (!smsProgramData || smsProgramData.length === 0) { return ''; }
  var programs = false ? smsProgramData.filter(function(p, i, arr) { return arr.findIndex(function(q) { return q.countryCode === p.countryCode; }) === i; }) : smsProgramData;
  return programs.map(program => {
    const flag = getCountryUnicodeFlag(program.countryCode);
    const countryName = getCountryName(program.countryCode);
    const callingCode = program.countryCallingCode || '';
    const sanitizedCountryCode = sanitizeHtml(program.countryCode || '');
    const sanitizedCountryName = sanitizeHtml(countryName || '');
    const sanitizedCallingCode = sanitizeHtml(callingCode || '');
    return '<option value="' + sanitizedCountryCode + '">' + sanitizedCountryName + ' ' + sanitizedCallingCode + '</option>';
  }).join('');
}

function getCountryName(countryCode) {
  if (window.MC?.smsPhoneData?.smsProgramDataCountryNames && Array.isArray(window.MC.smsPhoneData.smsProgramDataCountryNames)) {
    for (let i = 0; i < window.MC.smsPhoneData.smsProgramDataCountryNames.length; i++) {
      if (window.MC.smsPhoneData.smsProgramDataCountryNames[i].code === countryCode) { return window.MC.smsPhoneData.smsProgramDataCountryNames[i].name; }
    }
  }
  return countryCode;
}

function getDefaultPlaceholder(countryCode) {
  if (!countryCode || typeof countryCode !== 'string') { return '+1 000 000 0000'; }
  var mockPlaceholders = [{countryCode:'US',placeholder:'+1 000 000 0000'},{countryCode:'GB',placeholder:'+44 0000 000000'},{countryCode:'CA',placeholder:'+1 000 000 0000'},{countryCode:'AU',placeholder:'+61 000 000 000'},{countryCode:'DE',placeholder:'+49 000 0000000'},{countryCode:'FR',placeholder:'+33 0 00 00 00 00'},{countryCode:'ES',placeholder:'+34 000 000 000'},{countryCode:'NL',placeholder:'+31 0 00000000'},{countryCode:'BE',placeholder:'+32 000 00 00 00'},{countryCode:'CH',placeholder:'+41 00 000 00 00'},{countryCode:'AT',placeholder:'+43 000 000 0000'},{countryCode:'IE',placeholder:'+353 00 000 0000'},{countryCode:'IT',placeholder:'+39 000 000 0000'},{countryCode:'NO',placeholder:'+47 000 00 000'},{countryCode:'SE',placeholder:'+46 00 000 00 00'},{countryCode:'DK',placeholder:'+45 00 00 00 00'},{countryCode:'FI',placeholder:'+358 00 000 0000'},{countryCode:'NZ',placeholder:'+64 00 000 0000'}];
  const selectedPlaceholder = mockPlaceholders.find(function(item) { return item && item.countryCode === countryCode; });
  return selectedPlaceholder ? selectedPlaceholder.placeholder : mockPlaceholders[0].placeholder;
}

function updatePlaceholder(countryCode, fieldName) {
  if (!countryCode || !fieldName) { return; }
  const phoneInput = document.querySelector('#mce-' + fieldName);
  if (!phoneInput) { return; }
  const placeholder = getDefaultPlaceholder(countryCode);
  if (placeholder) { phoneInput.placeholder = placeholder; }
}

function updateCountryCodeInstruction(countryCode, fieldName) { updatePlaceholder(countryCode, fieldName); }
function setDefaultHelpText(countryCode) {}
function updateHelpTextCountryCode(countryCode, fieldName) { setDefaultHelpText(countryCode); }

function initializeSmsPhoneDropdown(fieldName) {
  if (!fieldName || typeof fieldName !== 'string') { return; }
  const dropdown = document.querySelector('#country-select-' + fieldName);
  const displayFlag = document.querySelector('#flag-display-' + fieldName);
  if (!dropdown || !displayFlag) { return; }
  const smsPhoneData = window.MC?.smsPhoneData;
  if (smsPhoneData && smsPhoneData.programs && Array.isArray(smsPhoneData.programs)) {
    dropdown.innerHTML = generateDropdownOptions(smsPhoneData.programs);
  }
  const defaultProgram = getDefaultCountryProgram(smsPhoneData?.defaultCountryCode, smsPhoneData?.programs);
  if (defaultProgram && defaultProgram.countryCode) {
    dropdown.value = defaultProgram.countryCode;
    const flagSpan = displayFlag?.querySelector('#flag-emoji-' + fieldName);
    if (flagSpan) {
      flagSpan.textContent = getCountryUnicodeFlag(defaultProgram.countryCode);
      flagSpan.setAttribute('aria-label', sanitizeHtml(defaultProgram.countryCode) + ' flag');
    }
    updateSmsLegalText(defaultProgram.countryCode, fieldName);
    updatePlaceholder(defaultProgram.countryCode, fieldName);
    updateCountryCodeInstruction(defaultProgram.countryCode, fieldName);
  }
  var smsNotRequiredRemoveCountryCodeEnabled = true;
  var smsFieldData = {"SMSPHONE":{"name":"SMSPHONE","type":"smsphone","required":true}};
  var smsField = Object.values(smsFieldData).find(function(f) { return f.name === fieldName && f.type === 'smsphone'; });
  var isRequired = smsField ? smsField.required : false;
  var shouldAppendCountryCode = smsNotRequiredRemoveCountryCodeEnabled ? isRequired : true;
  var phoneInput = document.querySelector('#mce-' + fieldName);
  if (phoneInput && defaultProgram.countryCallingCode && shouldAppendCountryCode) {
    phoneInput.value = defaultProgram.countryCallingCode;
  }
  displayFlag?.addEventListener('click', function(e) { dropdown.focus(); });
  dropdown?.addEventListener('change', function() {
    const selectedCountry = this.value;
    if (!selectedCountry || typeof selectedCountry !== 'string') { return; }
    const flagSpan = displayFlag?.querySelector('#flag-emoji-' + fieldName);
    if (flagSpan) {
      flagSpan.textContent = getCountryUnicodeFlag(selectedCountry);
      flagSpan.setAttribute('aria-label', sanitizeHtml(selectedCountry) + ' flag');
    }
    const selectedProgram = window.MC?.smsPhoneData?.programs.find(function(program) { return program && program.countryCode === selectedCountry; });
    var phoneInput = document.querySelector('#mce-' + fieldName);
    if (phoneInput && selectedProgram && selectedProgram.countryCallingCode && shouldAppendCountryCode) {
      phoneInput.value = selectedProgram.countryCallingCode;
    }
    updateSmsLegalText(selectedCountry, fieldName);
    updatePlaceholder(selectedCountry, fieldName);
    updateCountryCodeInstruction(selectedCountry, fieldName);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const smsPhoneFields = document.querySelectorAll('[id^="country-select-"]');
  smsPhoneFields.forEach(function(dropdown) {
    const fieldName = dropdown?.id.replace('country-select-', '');
    initializeSmsPhoneDropdown(fieldName);
  });
});